import React, { useState, useContext, useEffect} from 'react';
import { AppBar, Toolbar, Typography, IconButton, MenuList, Drawer, Link, List, ListItem, ListItemText,Box, Avatar } from '@mui/material';
import { ArrowBack, Menu, LightMode, DarkMode, Star, Add, Edit } from '@mui/icons-material'; // Added Star, Add, Edit
import { useLocation, useNavigate } from 'react-router-dom';
import Profile from './../pages/Profile';
import { WebSocketContext } from "../WebSocketContext";
import { useTheme } from '../contexts/ThemeContext';
import config from '../config';
import './../Profile.css';
import './../index.css';
import { getToken, storeToken, removeToken } from '../utils/auth';

function TitleBar() {
  const { userDetails, isRefreshing, stocks } = useContext(WebSocketContext);
  const { isDarkMode, toggleTheme } = useTheme(); // Used useTheme hook
  const location = useLocation();
  const navigate = useNavigate();
  const userId = Number(localStorage.getItem('userId'));
  const user_id = Number(localStorage.getItem('userId'));
  const parent_id = Number(localStorage.getItem('parentId'));
  const user_type = "brokerMLM";
  const clientName = userDetails.clientName;
  const isMLMClient = userDetails?.isMLMClient === "1";

  // Real-time clock state
  const [currentTime, setCurrentTime] = useState(new Date());

  // Real-time clock updates
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(timer);
  }, []);

  // Sticky scripts state
  const [stickyScripts, setStickyScripts] = useState(() => {
    try {
      const saved = localStorage.getItem('stickyScripts');
      return saved ? JSON.parse(saved) : { sticky1: null, sticky2: null };
    } catch (error) {
      console.error('Error loading sticky scripts:', error);
      return { sticky1: null, sticky2: null };
    }
  });

  const whatsappNumber = userDetails.supportContact;
  const whatsappMessage = 'Hello, I need support';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  const referralLink = `https://app.papertrade.co.in/register?ud=${userId}`;
  const message = encodeURIComponent(
    `Hi! Join using my referral link: ${referralLink}`
  );

  const shareOnWhatsApp = () => {
    const whatsappUrl = `https://wa.me/?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const [marqueeText, setMarqueeText] = useState(null);

    const getTodayScrollText = async (wsService) => {
        try 
        {  
          const response = await fetch(`${config.API_BASE_URL}getDefaultScrollText`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer 7c85cfc0ad2328331d4784ffedb97565154cd2016ed0b2b6843a53e7f2a2343d`
            },
            body: JSON.stringify({ }),
          });
          
          const data = await response.json();
          
          setMarqueeText(data.text); 

        } catch (error) {
          console.error('Error fetching marquee text:', error);
        }
    };

    useEffect(() => {
      getTodayScrollText();
      }, []);


  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  // Function to save sticky scripts to localStorage
  const saveStickyScripts = (scripts) => {
    try {
      localStorage.setItem('stickyScripts', JSON.stringify(scripts));
      setStickyScripts(scripts);
    } catch (error) {
      console.error('Error saving sticky scripts:', error);
    }
  };

  // Function to handle script selection
  const handleScriptSelection = (stickyType) => {
    navigate('/addScript', { 
      state: { 
        stickyType: stickyType,
        returnTo: location.pathname 
      } 
    });
  };

  // Function to remove sticky script
  const handleRemoveStickyScript = (stickyType) => {
    const newStickyScripts = {
      ...stickyScripts,
      [stickyType]: null
    };
    saveStickyScripts(newStickyScripts);
  };

  // Long press handlers
  const [longPressTimer, setLongPressTimer] = useState(null);
  const [showRemoveOption, setShowRemoveOption] = useState({ sticky1: false, sticky2: false });

  const handleLongPressStart = (stickyType) => {
    const timer = setTimeout(() => {
      setShowRemoveOption(prev => ({ ...prev, [stickyType]: true }));
    }, 500); // 500ms long press
    setLongPressTimer(timer);
  };

  const handleLongPressEnd = () => {
    if (longPressTimer) {
      clearTimeout(longPressTimer);
      setLongPressTimer(null);
    }
  };

  const handleNormalClick = (stickyType) => {
    if (showRemoveOption[stickyType]) {
      // If remove option is showing, hide it
      setShowRemoveOption(prev => ({ ...prev, [stickyType]: false }));
    } else {
      // Normal click - open trade bottom sheet
      const script = stickyScripts[stickyType];
      if (script) {
        // Dispatch event to open trade bottom sheet
        const event = new CustomEvent('openTradeBottomSheet', {
          detail: { script: script }
        });
        window.dispatchEvent(event);
      } else {
        // If no script selected, go to script selection
        handleScriptSelection(stickyType);
      }
    }
  };

  // Function to get LTP for a script
  const getScriptLTP = (script) => {
    if (!script || !stocks[script.instrument_token]) {
      return 'N/A';
    }
    const stockData = stocks[script.instrument_token];
    return stockData.LTP ? Number(stockData.LTP).toFixed(2) : 'N/A';
  };

  // Listen for script selection from AddScript page
  useEffect(() => {
    const handleScriptSelected = (event) => {
      const { stickyType, selectedScript } = event.detail;
      if (stickyType && selectedScript) {
        const newStickyScripts = {
          ...stickyScripts,
          [stickyType]: selectedScript
        };
        saveStickyScripts(newStickyScripts);
      }
    };

    window.addEventListener('stickyScriptSelected', handleScriptSelected);
    return () => {
      window.removeEventListener('stickyScriptSelected', handleScriptSelected);
    };
  }, [stickyScripts]);

  const handleNavigation = (path) => () => {
      setIsMLMMenu(false);
      
      if (path.startsWith('http')) {
        window.open(path, '_blank');
      } else {
        navigate(path);
        location.pathname = path;
      }
      setDrawerOpen(false);
  };

  const doLogin =  () => {
    localStorage.removeItem('authToken');
    navigate('/login');
    setDrawerOpen(false);
  };

  const showBackButton = location.pathname === '/profile' || location.pathname === '/addScript';

  const [isMLMMenuOpen, setIsMLMMenu] = useState(false);

  const toggleMLMMenu = () => {
    setIsMLMMenu(!isMLMMenuOpen);
  };

  return (
    <>
      <AppBar 
        position="fixed" 
        color="primary" 
        style={{ 
          backgroundColor: isDarkMode ? 'var(--bg-primary)' : '#FFFFFF', // Theme-aware background
          boxShadow: isDarkMode ? '0px 2px 5px -2px rgba(255,255,255,0.1)' : 'none', // Theme-aware shadow
          color: isDarkMode ? 'var(--text-primary)' : 'black', // Theme-aware text color
          borderBottom: isDarkMode ? '0px solid var(--border-color)' : 'none' // Theme-aware border
        }}
      >
        {/* Scrolling Market Indices */}
        <div className="scrolling-indices-header">
          <div className="scrolling-container">
            <div className="scrolling-content">
              {/* First set */}
              <div className="index-item">
                <div className="index-name">ZINC 31OCT2025</div>
                <div className="index-trend negative">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value negative">293.60</div>
                <div className="change-arrow negative">↓</div>
              </div>
              <div className="index-item">
                <div className="index-name">NIFTY</div>
                <div className="index-trend positive">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value positive">25052.60</div>
                <div className="change-arrow positive">↑</div>
              </div>
              <div className="index-item">
                <div className="index-name">SENSEX</div>
                <div className="index-trend positive">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value positive">81739.74</div>
                <div className="change-arrow positive">↑</div>
              </div>
              <div className="index-item">
                <div className="index-name">BANKNIFTY</div>
                <div className="index-trend positive">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value positive">48523.15</div>
                <div className="change-arrow positive">↑</div>
              </div>
              <div className="index-item">
                <div className="index-name">FINNIFTY</div>
                <div className="index-trend negative">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value negative">21456.80</div>
                <div className="change-arrow negative">↓</div>
              </div>
              {/* Duplicate set for seamless scrolling */}
              <div className="index-item">
                <div className="index-name">ZINC 31OCT2025</div>
                <div className="index-trend negative">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value negative">293.60</div>
                <div className="change-arrow negative">↓</div>
              </div>
              <div className="index-item">
                <div className="index-name">NIFTY</div>
                <div className="index-trend positive">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value positive">25052.60</div>
                <div className="change-arrow positive">↑</div>
              </div>
              <div className="index-item">
                <div className="index-name">SENSEX</div>
                <div className="index-trend positive">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value positive">81739.74</div>
                <div className="change-arrow positive">↑</div>
              </div>
              <div className="index-item">
                <div className="index-name">BANKNIFTY</div>
                <div className="index-trend positive">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value positive">48523.15</div>
                <div className="change-arrow positive">↑</div>
              </div>
              <div className="index-item">
                <div className="index-name">FINNIFTY</div>
                <div className="index-trend negative">
                  <div className="trend-line"></div>
                </div>
                <div className="index-value negative">21456.80</div>
                <div className="change-arrow negative">↓</div>
              </div>
            </div>
          </div>
        </div>
        <Toolbar style={{ minHeight:'45px' }}>
          
          {showBackButton && (
            <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
              <ArrowBack />
            </IconButton>
          )}
          {true && showBackButton==false && (
            <IconButton edge="start" color="inherit" onClick={toggleDrawer(true)}>
              <Menu />
            </IconButton>
          )}
          <Typography variant="h6" style={{fontSize:'18px', fontFamily:'Lato', fontWeight:600}}>
            {location.pathname === '/' && 'Quotes'} {/* Changed to Quotes */}
            {location.pathname === '/trades' && 'Trades'}
            {location.pathname === '/portfolio' && 'Portfolio'}
            {location.pathname === '/profile' && 'Profile'}
            {location.pathname === '/net-positions' && 'Portfolio'}
            {location.pathname === '/performance' && 'Performance'}
            {location.pathname === '/deposit' && 'Deposit'}
            {location.pathname === '/withdrawal' && 'Withdrawal'}
            {location.pathname === '/blocked-scripts' && 'Blocked Scripts'}
            {location.pathname === '/change-password' && 'Change Password'}
            {location.pathname === '/addScript' && 'Add Script'}
            {location.pathname === '/rejection-logs' && 'Rejection Logs'}
            {location.pathname === '/mlmdashboard' && 'MLM Trades'}
            {location.pathname === '/mlmportfolio' && 'MLM Portfolio'}
            {location.pathname === '/mlmperformance' && 'MLM Performance'}
          </Typography>
          {/* Action buttons for Quotes page */}
          {/* {location.pathname === '/' && (
            <>
              <IconButton color="inherit" onClick={() => { }}>
                <Star />
              </IconButton>
            </>
          )} */}
        </Toolbar>
        
        

        {/* Sticky Script Buttons */}
        {/* <div className="action-buttons">
          <div className="sticky-script-container">
            <button 
              style={{ borderRadius: '0px' }}
              className={`action-button sticky-script-button ${showRemoveOption.sticky1 ? 'remove-mode' : ''}`}
              onClick={() => handleNormalClick('sticky1')}
              onMouseDown={() => handleLongPressStart('sticky1')}
              onMouseUp={handleLongPressEnd}
              onMouseLeave={handleLongPressEnd}
              onTouchStart={() => handleLongPressStart('sticky1')}
              onTouchEnd={handleLongPressEnd}
              title={stickyScripts.sticky1 ? `${stickyScripts.sticky1.dispname} - ₹${getScriptLTP(stickyScripts.sticky1)}` : 'Select script for sticky position 1'}
            >
              {stickyScripts.sticky1 ? (
                <>
                  <span className="script-name">{stickyScripts.sticky1.dispname}</span>
                  <span className="script-ltp">₹{getScriptLTP(stickyScripts.sticky1)}</span>
                  {showRemoveOption.sticky1 && (
                    <span className="remove-indicator">Remove</span>
                  )}
                </>
              ) : (
                <>
                  <Add style={{ height: '16px', color: 'var(--accent-color)' }} />
                  <span>Press to select script</span>
                </>
              )}
            </button>
            {showRemoveOption.sticky1 && (
              <button 
                className="sticky-script-remove-confirm"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveStickyScript('sticky1');
                  setShowRemoveOption(prev => ({ ...prev, sticky1: false }));
                }}
                title="Confirm remove"
              >
                ✓
              </button>
            )}
          </div>
          
          <div className="sticky-script-container">
            <button 
              style={{ borderRadius: '0px' }}
              className={`action-button sticky-script-button ${showRemoveOption.sticky2 ? 'remove-mode' : ''}`}
              onClick={() => handleNormalClick('sticky2')}
              onMouseDown={() => handleLongPressStart('sticky2')}
              onMouseUp={handleLongPressEnd}
              onMouseLeave={handleLongPressEnd}
              onTouchStart={() => handleLongPressStart('sticky2')}
              onTouchEnd={handleLongPressEnd}
              title={stickyScripts.sticky2 ? `${stickyScripts.sticky2.dispname} - ₹${getScriptLTP(stickyScripts.sticky2)}` : 'Select script for sticky position 2'}
            >
              {stickyScripts.sticky2 ? (
                <>
                  <span className="script-name">{stickyScripts.sticky2.dispname}</span>
                  <span className="script-ltp">₹{getScriptLTP(stickyScripts.sticky2)}</span>
                  {showRemoveOption.sticky2 && (
                    <span className="remove-indicator">Remove</span>
                  )}
                </>
              ) : (
                <>
                  <Add style={{ height: '16px', color: 'var(--accent-color)' }} />
                  <span>Press to select script</span>
                </>
              )}
            </button>
            {showRemoveOption.sticky2 && (
              <button 
                className="sticky-script-remove-confirm"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveStickyScript('sticky2');
                  setShowRemoveOption(prev => ({ ...prev, sticky2: false }));
                }}
                title="Confirm remove"
              >
                ✓
              </button>
            )}
          </div>
        </div> */}

        {isRefreshing && <div style={{position: 'absolute', width: '100%', top: '10px'}}>
          <div style={{
            fontSize: '11px', 
            color: isDarkMode ? 'var(--text-primary)' : '#062c2f', 
            background: isDarkMode ? 'var(--bg-secondary)' : 'white', 
            padding: '0px 7px', 
            borderRadius: '11px', 
            margin: '0px auto', 
            width: '81px',
            border: isDarkMode ? '1px solid var(--border-color)' : 'none' // Theme-aware border
          }}>
            Refreshing....
          </div>
        </div>}
      </AppBar>

      

      {/* Compact Redesigned Drawer - Top to Bottom Slide */}
      <Drawer 
        anchor="top" 
        open={drawerOpen} 
        onClose={toggleDrawer(false)}
        transitionDuration={300}
        PaperProps={{
          sx: {
            backgroundColor: isDarkMode ? '#1a1a1a' : '#ffffff',
            color: isDarkMode ? '#ffffff' : '#000000',
            width: '100%',
            height: 'auto',
            maxHeight: '80vh',
            boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.5)' : '0 4px 20px rgba(0,0,0,0.15)',
            borderRadius: '0 0 16px 16px',
            overflow: 'hidden',
            zIndex: 999999999
          }
        }}
        SlideProps={{
          direction: 'down'
        }}
      >
        {/* Android-Style Date & Time Header */}
        <div style={{
          padding: '16px 16px 12px',
          background: isDarkMode ? '#1a1a1a' : '#f8f9fa',
          borderBottom: `1px solid ${isDarkMode ? '#333333' : '#e0e0e0'}`,
          position: 'relative'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <div>
              <Typography variant="h4" sx={{
                fontSize: '32px',
                fontWeight: 300,
                color: isDarkMode ? '#ffffff' : '#000000',
                lineHeight: 1
              }}>
                {new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })}
              </Typography>
              <Typography variant="body2" sx={{
                fontSize: '13px',
                color: isDarkMode ? '#aaaaaa' : '#666666',
                marginTop: '4px'
              }}>
                {new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })}
              </Typography>
            </div>
            {/* Close Button */}
            <button
            onClick={toggleDrawer(false)}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'none',
              border: 'none',
              color: isDarkMode ? '#ffffff' : '#000000',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = isDarkMode ? '#333333' : '#f0f0f0';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            ×
          </button>
          </div>
        </div>

        {/* User Details Section */}
        <div style={{
          padding: '16px',
          borderBottom: `1px solid ${isDarkMode ? '#333333' : '#e0e0e0'}`,
          background: isDarkMode ? '#1a1a1a' : '#ffffff'
        }}>
          {userDetails && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
                  <Avatar
                    sx={{
                  width: 40,
                  height: 40,
                  bgcolor: isDarkMode ? 'var(--accent-color)' : '#e3f2fd',
                  color: isDarkMode ? '#ffffff' : '#1976d2',
                  fontSize: '16px',
                  fontWeight: '600'
                }}
              >
                {userDetails.clientName && userDetails.clientName.split(" ").map((n) => n[0]).join("").toUpperCase()}
                  </Avatar>
              <div>
                <Typography variant="h6" sx={{ 
                  fontWeight: 600, 
                  color: isDarkMode ? '#ffffff' : '#000000',
                  fontSize: '16px',
                  marginBottom: '2px',
                  lineHeight: 1.2
                }}>
                    {userDetails.clientName}
                  </Typography>
                <Typography variant="body2" sx={{ 
                  color: isDarkMode ? '#aaaaaa' : '#666666',
                  fontSize: '12px'
                }}>
                    ID: {userDetails.clientId}
                  </Typography>
              </div>
            </div>
          )}

          {/* Compact Balance Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
            gap: '12px',
            marginBottom: '16px'
          }}>
            <div style={{
              background: isDarkMode ? '#2d2d2d' : '#ffffff',
              padding: '12px',
              borderRadius: '8px',
              border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
              textAlign: 'center'
            }}>
              <Typography variant="body2" sx={{ 
                color: isDarkMode ? '#aaaaaa' : '#666666',
                fontSize: '10px',
                fontWeight: 500,
                marginBottom: '2px',
                textTransform: 'uppercase',
                letterSpacing: '0.3px'
              }}>
                Available Margin
              </Typography>
              <Typography variant="h6" sx={{ 
                color: isDarkMode ? '#ffffff' : '#000000',
                fontSize: '14px',
                fontWeight: 700
              }}>
                ₹{Number(userDetails.availableMargin).toFixed(2)}
              </Typography>
                  </div>
            <div style={{
              background: isDarkMode ? '#2d2d2d' : '#ffffff',
              padding: '12px',
              borderRadius: '8px',
              border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
              textAlign: 'center'
            }}>
              <Typography variant="body2" sx={{ 
                color: isDarkMode ? '#aaaaaa' : '#666666',
                fontSize: '10px',
                fontWeight: 500,
                marginBottom: '2px',
                textTransform: 'uppercase',
                letterSpacing: '0.3px'
              }}>
                Available Balance
              </Typography>
              <Typography variant="h6" sx={{ 
                color: isDarkMode ? '#ffffff' : '#000000',
                fontSize: '14px',
                fontWeight: 700
              }}>
                ₹{Number(userDetails.mainAmount).toFixed(2)}
              </Typography>
                  </div>
              </div>
              
          {/* Compact Action Buttons */}
          {/*
          
          <div style={{
            display: 'flex',
            gap: '6px'
          }}>
                <button 
                  onClick={handleNavigation('/deposit')}
                  style={{
                flex: 1,
                padding: '10px 12px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                borderRadius: '6px',
                    cursor: 'pointer',
                fontSize: '13px',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(76, 175, 80, 0.2)'
              }}
              onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
              onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  Deposit
                </button>
                <button 
                  onClick={handleNavigation('/withdrawal')}
                  style={{
                flex: 1,
                padding: '10px 12px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                borderRadius: '6px',
                    cursor: 'pointer',
                fontSize: '13px',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(244, 67, 54, 0.2)'
              }}
              onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
              onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  Withdraw
                </button>
              </div> */}
          </div>

        {/* Compact Navigation Section */}
        <div style={{
          padding: '8px 0',
          flex: 1,
          overflowY: 'auto',
          maxHeight: '50vh'
        }}>
          {/* Main Navigation */}
          <div style={{ padding: '8px 0' }}>
            <div style={{
              padding: '12px 16px',
              fontSize: '12px',
              fontWeight: 600,
              color: isDarkMode ? '#888888' : '#666666',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Navigation
            </div>
            
            {[
              { icon: '🏠', label: 'Home', path: '/' },
              { icon: '🚫', label: 'Blocked Scripts', path: '/blocked-scripts' },
              { icon: '📋', label: 'Rejection Logs', path: '/rejection-logs' },
              { icon: '📊', label: 'Ledger', path: `https://suryanx.live/ledger_app_wo_login.php?ud=${userId}`, external: true },
              { icon: '🔐', label: 'Change Password', path: '/change-password' }
            ].map((item, index) => (
              <div
                key={index}
                onClick={() => handleNavigation(item.path)()}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  borderLeft: '3px solid transparent',
                  fontSize: '14px',
                  minHeight: '48px'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                  e.target.style.borderLeftColor = 'var(--accent-color)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderLeftColor = 'transparent';
                }}
              >
                <span style={{ fontSize: '16px', marginRight: '12px', width: '20px' }}>{item.icon}</span>
                <span style={{ 
                  fontSize: '13px',
                  fontWeight: 500,
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}>
                  {item.label}
                </span>
              </div>
            ))}
          </div>

          {/* Compact MLM Section */}
              {isMLMClient && (
            <div style={{ padding: '4px 0' }}>
              <div style={{
                padding: '8px 16px',
                fontSize: '11px',
                fontWeight: 600,
                color: isDarkMode ? '#888888' : '#666666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '4px'
              }}>
                MLM
              </div>
              
              <div
                onClick={toggleMLMMenu}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  borderLeft: '2px solid transparent'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                  e.target.style.borderLeftColor = 'var(--accent-color)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderLeftColor = 'transparent';
                }}
              >
                <span style={{ fontSize: '16px', marginRight: '12px', width: '20px' }}>
                  {isMLMMenuOpen ? '📊' : '📊'}
                </span>
                <span style={{ 
                  fontSize: '13px',
                  fontWeight: 500,
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}>
                  MLM Dashboard
                </span>
              </div>

                      {isMLMMenuOpen && (
                <div style={{ marginLeft: '16px' }}>
                  {[
                    { icon: '📈', label: 'Trades', path: '/mlmdashboard' },
                    { icon: '💼', label: 'Portfolio', path: '/mlmportfolio' },
                    { icon: '📊', label: 'Performance', path: '/mlmperformance' },
                    { icon: '📋', label: 'MLM Ledger', path: `https://bluerock.live/broledger_mlm.php?ud=${userId}&r=${user_type}&mid=${parent_id}`, external: true },
                    { icon: '📄', label: 'MLM Summary', path: `https://bluerock.live/summaryReport_mlm.php?ud=${userId}&r=${user_type}&mid=${parent_id}`, external: true }
                  ].map((item, index) => (
                    <div
                      key={index}
                      onClick={() => handleNavigation(item.path)()}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '6px 16px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        borderLeft: '2px solid transparent'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                        e.target.style.borderLeftColor = 'var(--accent-color)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.borderLeftColor = 'transparent';
                      }}
                    >
                      <span style={{ fontSize: '14px', marginRight: '12px', width: '18px' }}>{item.icon}</span>
                      <span style={{ 
                        fontSize: '12px',
                        fontWeight: 500,
                        color: isDarkMode ? '#cccccc' : '#333333'
                      }}>
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Compact Support Section */}
          <div style={{ padding: '4px 0' }}>
            <div style={{
              padding: '8px 16px',
              fontSize: '11px',
              fontWeight: 600,
              color: isDarkMode ? '#888888' : '#666666',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '4px'
            }}>
              Support
            </div>
            
            {[
              { icon: '🔗', label: 'Share App', action: shareOnWhatsApp },
              { icon: '💬', label: 'Support', path: whatsappLink, external: true }
            ].map((item, index) => (
              <div
                key={index}
                onClick={item.action || handleNavigation(item.path)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  borderLeft: '2px solid transparent'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                  e.target.style.borderLeftColor = 'var(--accent-color)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderLeftColor = 'transparent';
                }}
              >
                <span style={{ fontSize: '16px', marginRight: '12px', width: '20px' }}>{item.icon}</span>
                <span style={{ 
                  fontSize: '13px',
                  fontWeight: 500,
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}>
                  {item.label}
                </span>
              </div>
            ))}
          </div>

          {/* Theme Toggle Section */}
          <div style={{ padding: '4px 0' }}>
            <div style={{
              padding: '8px 16px',
              fontSize: '11px',
              fontWeight: 600,
              color: isDarkMode ? '#888888' : '#666666',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '4px'
            }}>
              Appearance
            </div>
            
            <div
              onClick={toggleTheme}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 16px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                borderLeft: '2px solid transparent'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                e.target.style.borderLeftColor = 'var(--accent-color)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.borderLeftColor = 'transparent';
              }}
            >
              <span style={{ fontSize: '16px', marginRight: '12px', width: '20px' }}>
                {isDarkMode ? '🌞' : '🌙'}
              </span>
              <span style={{ 
                fontSize: '13px',
                fontWeight: 500,
                color: isDarkMode ? '#ffffff' : '#000000'
              }}>
                {isDarkMode ? 'Light Mode' : 'Dark Mode'}
              </span>
            </div>
          </div>

          {/* Compact Logout Section */}
          <div style={{
            padding: '12px 16px',
            borderTop: `1px solid ${isDarkMode ? '#333333' : '#e0e0e0'}`,
            marginTop: '8px'
          }}>
            <div
              onClick={doLogin}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 12px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                borderRadius: '6px',
                backgroundColor: isDarkMode ? '#2d2d2d' : '#f8f9fa',
                border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = isDarkMode ? '#404040' : '#e9ecef';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <span style={{ fontSize: '16px', marginRight: '12px', color: '#f44336' }}>🚪</span>
              <span style={{ 
                fontSize: '13px',
                fontWeight: 600,
                color: '#f44336'
              }}>
                Logout
              </span>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default TitleBar;